var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"ADropdownMenuSelector",class:_vm.classes},[_c('span',[_vm._v(" "+_vm._s(_vm.selectionText)+" ")]),(_vm.useIcon)?_c('span',[(!_vm.dropdownActive)?_c('chevron-down-icon',{attrs:{"size":_vm.iconSize}}):_c('x-icon',{attrs:{"size":_vm.iconSize}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }